/* eslint-disable complexity */

import { TimeInput } from '@/components/Input/TimeInput';
import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';
import { useFieldContext } from '@/domain/mitarbeiter/features/anlageassistent/components/form/hooks';
import { FieldProps } from '@/domain/mitarbeiter/features/anlageassistent/components/form/types';
import { Input } from '@e2n/ui/v2';
import { MaskitoOptions, maskitoUpdateElement } from '@maskito/core';
import { maskitoEventHandler } from '@maskito/kit';
import { useMaskito } from '@maskito/react';

export function HoursInput({
  label,
  description,
  placeholder,
  isRequired,
  className,
  suffix,
  maxHours,
  maxLength,
  ...inputProps
}: FieldProps &
  React.ComponentProps<typeof TimeInput> & {
    suffix?: string;
    maxHours?: number;
  }) {
  const maxHourDigits = maxLength ?? 4;
  const maxInputLength = maxHourDigits + 3;

  const options: MaskitoOptions = {
    mask: new RegExp(
      `^$|^\\d{1,${maxHourDigits}}$|^\\d{1,${maxHourDigits}}:$|^\\d{1,${maxHourDigits}}:\\d$|^\\d{1,${maxHourDigits}}:[0-5]\\d$`,
    ),
    plugins: [
      maskitoEventHandler('blur', (element) => {
        const [hours = '', minutes = ''] = element.value.split(':');
        if (!hours) return;
        if (maxHours && Number(hours) > maxHours) {
          maskitoUpdateElement(element, `${maxHours}:00`);
          return;
        }
        const normalizedMinutes =
          minutes === ''
            ? '00'
            : minutes.length === 1 && Number(minutes) < 6
              ? minutes.padEnd(2, '0')
              : minutes.length === 1 && Number(minutes) >= 6
                ? minutes.padStart(2, '0')
                : minutes;
        const normalizedHours =
          hours.length < 2 ? hours.padStart(2, '0') : hours;

        maskitoUpdateElement(
          element,
          `${normalizedHours}:${normalizedMinutes}`,
        );
      }),
    ],
  };
  const field = useFieldContext<string | undefined>();
  const maskito = useMaskito({ options });

  return (
    <FieldBase
      label={label}
      description={description}
      isRequired={isRequired}
      className={className}>
      <Input
        id={field.name}
        name={field.name}
        ref={maskito}
        defaultValue={field.state.value ?? ''}
        onBlur={(e) => {
          field.handleChange(e.target.value);
          field.handleBlur();
        }}
        placeholder={placeholder ?? '--:--'}
        maxLength={maxInputLength}
        type="text"
        {...inputProps}
        showSuffix={!!suffix}
        suffix={suffix}
      />
    </FieldBase>
  );
}
